import React, {Component} from 'react';
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import Articles from "../articles/articles";
import { Responsive, Container, Grid, Image } from 'semantic-ui-react';
import HistoryItem from "./historyitem";
import FacebookProvider, { Page } from 'react-facebook';
import YouTube from 'react-youtube';
import KID1 from './img/kid1.png';
import KID2 from './img/kid2.png';
import KID3 from './img/kid3.png';
import KID4 from './img/kid4.png';
import KID5 from './img/kid5.png';
import KID6 from './img/kid6.png';
import KID7 from './img/kid7.png';
import KID8 from './img/kid8.png';
import KID9 from './img/kid9.png';
import KID10 from './img/kid10.png';
import KID11 from './img/kid11.png';
import KID12 from './img/kid12.png';
import KID13 from './img/kid13.png';
import KID14 from './img/kid14.png';
import KID15 from './img/kid15.png';
import KID16 from './img/kid16.png';
import KID17 from './img/kid17.png';
import KID18 from './img/kid18.png';
import KID19 from './img/kid19.png';
import KID20 from './img/kid20.png';
import KID21 from './img/kid21.png';
import KID22 from './img/kid22.png';
import KID23 from './img/kid23.png';
import KID24 from './img/kid24.png';
import KID25 from './img/kid25.png';
import KID26 from './img/kid26.png';
import KID27 from './img/kid27.png';
import CoreValues from './img/core.jpg';
import HistoryData from "./data/history.json";
import './kideract.css';

class Kideract extends Component {

  componentWillMount(){


  }

  render() {
    return (
      <div className="Homepage">

        <Header page="aboutus"/>

          <div className="homeContentWhite">
            <a id="overview">
              <Container>
              <div className="AboutUsTitle">
                Kideract Club of Central
              </div>
              <div className="AboutUsText left">
To extend our outreach for more varieties of service participants, <b>Kideract Club of Central</b> chartered in 2015 by a group of 2nd generation of Rotary Club of Central’s members.
<br/><br/>
Our signature annual events include:
<br/><br/>
<b>Summer Annual Party</b><br/>
•	Review of annual service events<br/>
•	Souvenirs preparation for elderly for
香港聖公會福利協會西環長者綜合服務中心<br/>
•	Annual Review and Award Presentations<br/>
<br/><br/>
<b>Fundraising Walkathon in the fall</b><br/>
•	Walk 3km round the Peak Circle and raise fund for RCC service events<br/>
•	Beneficiaries include “Voice of Harp” and “Hong Kong Down Syndrome Association”<br/>
<br/><br/>
<b>Spring Beach Cleaning</b><br/>
•	Visit and Cleanup a coastal beach<br/>
•	Emphasize the environmental friendly message for members: Reduce, Recycle and Reuse<br/>
<br/><br/>
<b>We welcome all to join us to serve!</b>
<br/><br/>
Current Members: 28 pax<br/>
Age: from 0 to 15 years old<br/>
Language: Cantonese, English, Mandarin, baby language<br/>
Music instruments: piano, cello, ukulele, violin, guitar<br/>
Pre-requisite: 2nd generation of RCC members and friends of RCC<br/>
</div>
                <div className="AboutUsTitle">
                  Kideract Club of Central – by PP Olivia 2015
                </div>
                <div className="AboutUsText left">
                I recalled the very first time my daughter joined RCC visiting some elderly in Kowloon Bay when she was only four years old. Not only she had an eye-opened experience, the elderly were also more pleased and enjoyable with the little ones.  It was my Rotary moment when my daughter whispered to me, “Mom, sharing is caring!” after this service event.
                </div>
                <div className="AboutUsText left">
                  When Rotary Club of Central (RCC) was chartered in 2009, we had 33 members of which 10 were married with 7 kids. After seven years, despite some members’ turnover, we’re now having 32 members and 22 are married with 24 kids. It is a blessing figure!  We have a net increase of 11 kids in 7 years!
                  <table>
                    <tr>
                      <th>Rotary Club of Central</th>
                      <th>2009</th>
                      <th>2015</th>
                      <th>Net change *</th>
                    </tr>
                    <tr>
                      <td>
                        Members
                      </td>
                      <td>33</td>
                      <td>32</td>
                      <td>-1</td>
                    </tr>
                    <tr>
                      <td>
                        Married
                      </td>
                      <td>10</td>
                      <td>22</td>
                      <td>+10</td>
                    </tr>
                    <tr>
                      <td>
                        Kids
                      </td>
                      <td>7</td>
                      <td>24</td>
                      <td>+11</td>
                    </tr>
                  </table>
                  <i>*incl. members' turnover</i>
                </div>
                <div className="AboutUsText left">
                I recalled the very first time my daughter joined RCC visiting some elderly in Kowloon Bay when she was only four years old. Not only she had an eye-opened experience, the elderly were also more pleased and enjoyable with the little ones.  It was my Rotary moment when my daughter whispered to me, “Mom, sharing is caring!” after this service event.
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={KID1} /><Image className="col-12 col-sm-6 col-md-3" src={KID2} />
                </div>
                <div className="AboutUsText left">
                  Parents in Hong Kong, nonetheless, are in the same boat following the same wave of currents which push us to shape our kids, or at least to achieve some “achievements”.  Having a little kid reminding ourselves the core value of service is indeed precious.
<br/><br/>*******************************<br/><br/>
Earlier this year, a couple of RCC parents sat down looking at our kids’ figure and joked about forming a kids’ club. We tried to gather our kids for play dates and provisional club meetings, but frankly it is the hardest thing to do as our kids’ schedule could be incredibly busy and tight.

                </div>
                  <div className="kideract-image-group">
                      <Image id="kideract-image" src={KID3} />
                      <Image id="kideract-image" src={KID4} />
                      <Image id="kideract-image" src={KID5} />
                      <Image id="kideract-image" src={KID6} />
                  </div>
                <div className="AboutUsText left">
                  After a couple months of gatherings, they have provisional logo designed imitating the RCC’s one with the shadow of a children playground. They proposed to have their 1st fundraising walkathon for the Jockey Club New Page Inn through the service of Harp.  Two weeks prior to the walkathon, the kids were busy looking for sponsorships, preparing presentation, and drawing some bookmarks for the walkathon souvenirs.  On 2 December 2015, charter members of Kideract Club visited RCC and presented their plans to District Governor Peter Pang.
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={KID7} /><Image className="col-12 col-sm-6 col-md-3" src={KID8} />
                </div>
                <div className="AboutUsText left">
                <a href="https://drive.google.com/open?id=0BxLRbvRktTr8YXBwa0xCRjR0S00">https://drive.google.com/open?id=0BxLRbvRktTr8YXBwa0xCRjR0S00</a>
                <br/>(click to watch presentation video)<br/>
                <a href="https://drive.google.com/open?id=0BxLRbvRktTr8SWRwY2R2OGpsTG8">https://drive.google.com/open?id=0BxLRbvRktTr8SWRwY2R2OGpsTG8</a>
                <br/>(click to see presentation file)<br/>
                On 5 December 2015, despite the chilly and foggy weather, the Kideract Club of Central members and friends gathered early in the morning at the Victoria Peak and walked along the Peak Circle for 3km and raised more than $10,000 from more than 40 participants.
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={KID9} /><Image className="col-12 col-sm-6 col-md-3" src={KID10} /><Image className="col-12 col-sm-6 col-md-3" src={KID11} />
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={KID12} /><Image className="col-12 col-sm-6 col-md-3" src={KID13} />
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={KID14} /><Image className="col-12 col-sm-6 col-md-3" src={KID15} />
                </div>
                <div className="AboutUsText left">
                After the walkathon, we presented certificate of completion to all participating members and friends.
                <br/><a href="https://drive.google.com/open?id=0BxLRbvRktTr8M2RHZUxST1g5cVE">https://drive.google.com/open?id=0BxLRbvRktTr8M2RHZUxST1g5cVE</a>
                <br/>(Click to watch walkathon)<br/>
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={KID16} /><Image className="col-12 col-sm-6 col-md-3" src={KID17} /><Image className="col-12 col-sm-6 col-md-3" src={KID18} /><Image className="col-12 col-sm-6 col-md-3" src={KID19} />
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={KID20} /><Image className="col-12 col-sm-6 col-md-3" src={KID21} /><Image className="col-12 col-sm-6 col-md-3" src={KID22} />
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={KID23} /><Image className="col-12 col-sm-6 col-md-3" src={KID24} /><Image className="col-12 col-sm-6 col-md-3" src={KID25} /><Image className="col-12 col-sm-6 col-md-3" src={KID26} />
                </div>
                <div className="AboutUsText left">
                On the following day, we passed the check to the Jockey Club NewPage Inn at the “Voice of Harp” annual party. What a fruitful and meaningful event Kideract Club of Central initiated!
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12" src={KID27} />
                </div>
                <div className="AboutUsText left">
                Looking forward, members of Kideract Club will meet again and plan to have more service events every quarter. Stay tune, we’ll be back!
                <br/><b>Kideract Club of Central</b>
                <br/>Members: 24
                <br/>Age: from 1 to 10 years old
                <br/>Language: Cantonese, English, Mandarin, baby language
                <br/>Music instruments: piano, cello, ukulele, violin
                <br/>Pre-requisite: 2nd generation of RCC members
                </div>
              </Container>
            </a>
          </div>

        <Footer/>
      </div>
    );
  }
}

export default Kideract;
